(function () {
  WebFontConfig = {
    google: { families: ['Open+Sans:300,400,600,700,800:latin', 'Lato:700:latin'] }
  };
  
  var wf = document.createElement('script');
  wf.src = ('https:' == document.location.protocol ? 'https' : 'http') +
            '://cdn.etix.com/shared/js/webfont-1.5.6.js';
  wf.type = 'text/javascript';
  wf.integrity = 'sha384-LnKd8nE37ZWFxvSq6CY40gWRTaZFyYoemkEDfBBPKZ8tAnLbaKeLHql3GD21/gi/'
  wf.crossOrigin = 'anonymous';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
}());

function setLanguage() {
  _.forEach(translations, function(k, v) {
    if(v === language) {
      $(".series__description h6").text(k.description);
      $(".series__schedule h6").text(k.selectDate);
      $(".timeslot h6").text(k.timeslot);
      $(".button").text(k.reservation);
    } else {
      return;
    }
  });
}

moment().format();
setLanguage();

$(document).on('click', 'a[href^="#seating-chart"], a[href^="#top"]', function (e) {
  e.preventDefault();

  var target = this.hash;
  var $target = $(target);

  $('html, body').stop().animate({
      'scrollTop': $target.offset().top
  }, 900, 'swing');
});

$(window).on('scroll', function() {
   if ($(this).scrollTop() > 400) {
     $('.back-to-top').addClass('back-to-top--open');
   } else {
     $('.back-to-top').removeClass('back-to-top--open');
   }
});

$(document).ready(function() {
  var $body = $('body');
  
  $('.toggle-mobile-menu').on('click', function() {
    $body.toggleClass('mobile-menu--open');
  });
  
  $('.body-wrapper__overlay').on('click', function() {
    $body.removeClass('mobile-menu--open');
  });
});
